import "core-js/modules/es.array.index-of";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { addSharing, updSharing } from "@/api/financial/consumptionDetails";
import { serchSelect } from "@/mixins/index";
export default {
  props: {
    searchchannel: {
      type: Array,
      default: []
    }
  },
  mixins: [serchSelect],
  data: function data() {
    return {
      dialogFormVisible: false,
      searchData: {
        id: "",
        channel: "",
        country: "",
        sharing_percent: ""
      },
      rules: {
        channel: [{
          required: true,
          message: this.$t('channel'),
          trigger: "blur"
        }],
        sharing_percent: [{
          required: true,
          message: this.$t('sharingPercent'),
          trigger: "blur"
        }]
      },
      formLabelWidth: "80px",
      issubstitution: false
    };
  },
  created: function created() {
    this.getAllchannel();
  },
  methods: {
    proving: function proving(e) {
      var val = e;

      if (val.indexOf(".") != -1) {
        val = val.substr(0, 5);
      }

      this.searchData.sharing_percent = val;
    },
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var ds, k;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (data) {
                  ds = {};

                  for (k in _this.searchData) {
                    ds[k] = data[k] ? data[k] : '';
                  }

                  _this.searchData = _objectSpread({}, ds);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.searchData.id = '';
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var req = _this2.searchData.id ? updSharing : addSharing;
          req(_this2.searchData).then(function (res) {
            if (res.status == 200) {
              Message.success(_this2.$t('operationSuccess'));

              _this2.$emit("refreshDataList");

              _this2.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.searchData = {
        id: this.searchData.id,
        sharing_percent: '',
        country: '',
        channel: ''
      };
      this.$refs.ruleForm.resetFields();
    }
  }
};